import React, { FC } from 'react';
import { toast } from 'react-toastify';
import { useFormContext } from 'react-hook-form';
import { FieldWrapper } from '@td-client-frontend/common';
import { DatePicker, TextField, Radio } from '../../../components/ReactHookForm';
import { GroupGridRowWithLabel } from '../GroupHelperComponents';
import Modal from '../../../components/Modal/NewModal';

interface FutureProductsProps {
  path: string;
  initialData: Record<string, Record<string, any>>;
  onClose: () => void;
}

const FutureProducts: FC<FutureProductsProps> = ({ path, initialData, onClose }) => {
  const { setValue } = useFormContext();

  const handleCloseModal = () => {
    setValue(path, initialData, { shouldValidate: true });
    onClose();
  };

  const onSave = () => {
    toast.success('Please click Update to submit your changes', { position: 'top-center' });
    onClose();
  };

  return (
    <>
      <Modal
        isOpen
        onClose={handleCloseModal}
        header="Schedule price update"
        actions={[
          { title: 'Cancel', kind: 'secondary', autoClose: false, onClick: handleCloseModal },
          {
            title: 'Save',
            kind: 'primary',
            autoClose: false,
            onClick: onSave
          }
        ]}
        size="medium"
      >
        <div className="flex flex-col p-6">
          <GroupGridRowWithLabel label="Gen Med Service">
            <DatePicker
              name={`${path}.GM.start_dt`}
              label="Effective Date"
              wrapperClasses="col-span-3"
              placeholder="MM/DD/YYYY"
            />
            <TextField name={`${path}.GM.member_copay`} label="Member Pays" wrapperClasses="col-span-3" type="number" />
            <FieldWrapper
              label="Copay May Be Less"
              labelClasses="block mb-2 text-sm font-bold tracking-wide font-effra text-black-default"
              className="col-span-3 flex items-center justify-between flex-col h-full"
            >
              <div className="flex gap-4">
                <Radio name={`${path}.could_be_less`} id={`${path}.could_be_less.Y`} label="Yes" value="true" />
                <Radio name={`${path}.could_be_less`} id={`${path}.could_be_less.N`} label="No" value="false" />
              </div>
            </FieldWrapper>
            <FieldWrapper
              label="USGH APP Opt-Out"
              labelClasses="block mb-2 text-sm font-bold tracking-wide font-effra text-black-default"
              className="col-span-3 flex items-center justify-between flex-col h-full"
            >
              <div className="flex gap-4">
                <Radio name={`${path}.app_opt_out`} id={`${path}.app_opt_out.Y`} label="Yes" value="true" />
                <Radio name={`${path}.app_opt_out`} id={`${path}.app_opt_out.N`} label="No" value="false" />
              </div>
            </FieldWrapper>
          </GroupGridRowWithLabel>
          <GroupGridRowWithLabel label="Derm Service">
            <DatePicker
              name={`${path}.DERM.start_dt`}
              label="Effective Date"
              wrapperClasses="col-span-3"
              placeholder="MM/DD/YYYY"
            />
            <TextField
              name={`${path}.DERM.member_copay`}
              label="Member Pays"
              wrapperClasses="col-span-3"
              type="number"
            />
          </GroupGridRowWithLabel>
          <GroupGridRowWithLabel label="Mental Health">
            <DatePicker
              name={`${path}.BH.start_dt`}
              label="Effective Date"
              wrapperClasses="col-span-3"
              placeholder="MM/DD/YYYY"
            />
            <TextField name={`${path}.BH.BHINIT`} label="Initial Psyc" wrapperClasses="col-span-3" type="number" />
            <TextField name={`${path}.BH.BHNPT`} label="Followup Psyc" wrapperClasses="col-span-3" type="number" />
            <TextField name={`${path}.BH.BHMD`} label="Therapy NonMD" wrapperClasses="col-span-3" type="number" />
          </GroupGridRowWithLabel>
        </div>
      </Modal>
    </>
  );
};

export default FutureProducts;
